import React from 'react';
import { Route,withRouter} from 'react-router-dom';
// Router
import {routes,RouteWithSubRoutes} from './routes';
// Components
import Auth from './components/Auth';
// UI
import {Container} from '@material-ui/core';

import Sidemenu from './pages/sideMenu';

const Ws=(props:any)=>{
    return(
        
          <Auth>
            
              <Sidemenu/>
              <Container maxWidth="xl" className="container">
                {routes.map((route, i) => (
                  <RouteWithSubRoutes key={i} {...route} />
                ))}
              </Container>
            
          </Auth>
        
    )
}

export default withRouter(Ws);